import sevenEleven from "../../../assets/images/paycard/paycard-7eleven.png";
import amex from "../../../assets/images/paycard/paycard-amex.png";
import banorte from "../../../assets/images/paycard/paycard-banorte.png";
import bbva from "../../../assets/images/paycard/paycard-bbva.png";
import carnet from "../../../assets/images/paycard/paycard-carnet.png";
import chedraui from "../../../assets/images/paycard/paycard-chedraui.png";
import cie from "../../../assets/images/paycard/paycard-cie.png";
import citibanamex from "../../../assets/images/paycard/paycard-citibanamex.png";
import coppel from "../../../assets/images/paycard/paycard-coppel.png";
import edenred from "../../../assets/images/paycard/paycard-edenred.png";
import elektra from "../../../assets/images/paycard/paycard-elektra.png";
import extra from "../../../assets/images/paycard/paycard-extra.png";
import farmBenavides from "../../../assets/images/paycard/paycard-farm-benavides.png";
import farmEsquivar from "../../../assets/images/paycard/paycard-farm-esquivar.png";
import hsbc from "../../../assets/images/paycard/paycard-hsbc.png";
import inbursa from "../../../assets/images/paycard/paycard-inbursa.png";
import mastercard from "../../../assets/images/paycard/paycard-mastercard.png";
import oxxo from "../../../assets/images/paycard/paycard-oxxo.png";
import red from "../../../assets/images/paycard/paycard-red.png";
import santander from "../../../assets/images/paycard/paycard-santander.png";
import scotiabank from "../../../assets/images/paycard/paycard-scotiabank.png";
import siVale from "../../../assets/images/paycard/paycard-si-vale.png";
import sodexo from "../../../assets/images/paycard/paycard-sodexo.png";
import spei from "../../../assets/images/paycard/paycard-spei.png";
import telecomm from "../../../assets/images/paycard/paycard-telecomm.png";
import visa from "../../../assets/images/paycard/paycard-visa.png";
import srpa from "../../../assets/images/paycard/srpa.png";

const cardsLogos = {
  seveneleven: {
    label: "7 Eleven",
    src: sevenEleven,
  },
  amex: {
    label: "Amex",
    src: amex,
  },
  banorte: {
    label: "Banorte",
    src: banorte,
  },
  bbva: {
    label: "BBVA",
    src: bbva,
  },
  carnet: {
    label: "Carnet",
    src: carnet,
  },
  chedraui: {
    label: "Chedraui",
    src: chedraui,
  },
  cie: {
    label: "CIE",
    src: cie,
  },
  citibanamex: {
    label: "Citi Banamex",
    src: citibanamex,
  },
  coppel: {
    label: "Coppel",
    src: coppel,
  },
  edenred: {
    label: "Edenred",
    src: edenred,
  },
  elektra: {
    label: "Elektra",
    src: elektra,
  },
  extra: {
    label: "Extra",
    src: extra,
  },
  farmbenavides: {
    label: "Farm Benavides",
    src: farmBenavides,
  },
  farmesquivar: {
    label: "Farm Esquivar",
    src: farmEsquivar,
  },
  hsbc: {
    label: "HSBC",
    src: hsbc,
  },
  inbursa: {
    label: "Inbursa",
    src: inbursa,
  },
  mast: {
    label: "Mastercard",
    src: mastercard,
  },
  oxxo: {
    label: "OXXO",
    src: oxxo,
  },
  red: {
    label: "Red",
    src: red,
  },
  santander: {
    label: "Santander",
    src: santander,
  },
  scotiabank: {
    label: "Scotiabank",
    src: scotiabank,
  },
  vale: {
    label: "Si Vale",
    src: siVale,
  },
  sodexo: {
    label: "Sodexo",
    src: sodexo,
  },
  spei: {
    label: "SPEI",
    src: spei,
  },
  telecomm: {
    label: "Telecomm",
    src: telecomm,
  },
  visa: {
    label: "Visa",
    src: visa,
  },
  srpa: {
    label: "SRPA",
    src: srpa,
  },
};

export default cardsLogos;
